import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Stars from './Stars'

const RatingBreakdown = ({ stats = [] }) => {
  const { t } = useTranslation(['organisation'])
  const zeroRatingCount = useMemo(() => {
    return stats.reduce((acc, s) => {
      if (s.rating === 0) {
        acc += s.reviewCount
      }
      return acc
    }, 0)
  }, [stats])

  const filteredStats = useMemo(() => {
    return stats.filter((s) => s.rating !== 0)
  }, [stats])

  return (
    <div className="rating-breakdown">
      {filteredStats.map((s, index) => (
        <div key={index} className="rating-breakdown__row">
          <p className="star-number">{s.rating}</p>
          <Stars starsValue={0} starsTotal={1} />
          <div className="rating-bar">
            <div className="rating-bar__inner" style={{ width: `${s.percentage}%` }} />
          </div>
          <p className="rating-breakdown__text">{s.reviewCount}</p>
        </div>
      ))}
      {zeroRatingCount > 0 && (
        <p className="rating-breakdown__text">
          {t('organisation:reputationManagement.ratingBreakdown.noRatingReviews', {
            count: zeroRatingCount,
          })}
        </p>
      )}
    </div>
  )
}

RatingBreakdown.propTypes = {
  stats: PropTypes.array,
}

export default RatingBreakdown
